export const RESET_STATE = 'ORGANIZATION/JOIN/RESET_STATE' as const
export const SUBMIT_USER_EMAIL = 'ORGANIZATION/JOIN/SUBMIT_USER_EMAIL' as const
export const SUBMIT_USER_PASSWORD =
  'ORGANIZATION/JOIN/SUBMIT_USER_PASSWORD' as const
export const SET_USER_INFORMATIONS =
  'ORGANIZATION/JOIN/SET_USER_INFORMATIONS' as const
export const CHECK_DOMAIN = 'ORGANIZATION/CREATION/CHECK_DOMAIN' as const
export const CHANGE_STEP = 'ORGANIZATION/CREATION/CHANGE_STEP' as const
export const CREATE = 'ORGANIZATION/CREATION/CREATE' as const
export const JOIN = 'ORGANIZATION/CREATION/JOIN' as const
export const SET_ORGANIZATION_DETAILS =
  'ORGANIZATION/JOIN/SET_ORGANIZATION_DETAILS' as const
export const USER_PICKS_EMAIL_SIGNUP =
  'ORGANIZATION/JOIN/USER_PICKS_EMAIL_SIGNUP' as const
export const SET_EMAIL_VERIFICATION_CODE =
  'ORGANIZATION/JOIN/SET_EMAIL_VERIFICATION_CODE' as const
export const VERIFY_EMAIL_VERIFICATION_CODE =
  'ORGANIZATION/JOIN/VERIFY_EMAIL_VERIFICATION_CODE' as const
export const START_AUTO_JOIN_PROCESS =
  'ORGANIZATION/JOIN/START_AUTO_JOIN_PROCESS' as const
export const FETCH_ORGANIZATION =
  'ORGANIZATION/JOIN/FETCH_ORGANIZATION' as const
export const SET_INVITE_TOKEN = 'ORGANIZATION/JOIN/SET_INVITE_TOKEN' as const
export const SET_USER_OAUTH_INFORMATIONS_ON_REJOIN =
  'ORGANIZATION/JOIN/SET_AUTOJOIN_USER_INFOS' as const
